import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const AwardOutline = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      d="M18.53 9.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Zm-5 8.433A8.5 8.5 0 0 0 18.789 15l1.848 3.2a.3.3 0 0 1-.276.45l-3.013-.162-1.427 2.733a.3.3 0 0 1-.527.008zm-2.883.017a8.5 8.5 0 0 1-5.259-2.932l-1.847 3.2a.3.3 0 0 0 .276.45l3.013-.162 1.426 2.732a.3.3 0 0 0 .527.009z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(AwardOutline) as SvgIcon;
export { ForwardRef as ReactComponent };
